/**
 * Icon and Text block script.
 *
 * Single icon + heading + description section. One soft fade-up on
 * scroll-into-view — no internal staggering since the elements read as a
 * single composed unit.
 */

import { revealOnScroll, motionTokens } from '@/motion-primitives';

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.rmh-icon-and-text').forEach((section) => {
		revealOnScroll(section, {
			duration: motionTokens.durMd,
		});
	});
});
